export const bankInformation = [
  {
    label: { en: "Bank name", de: "Bank name" },
    icon: (
      <svg
        className="size-5 text-primary-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5zM12 7c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 7.5c2.33 0 7 1.17 7 3.5V19H5v-1c0-2.33 4.67-3.5 7-3.5z" />
      </svg>
    ),
    key: "bankName",
  },
  {
    label: { en: "Sort code", de: "BLZ" },
    icon: (
      <svg
        className="size-5 text-primary-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2v-4H8l4-4 4 4h-4v4z" />
      </svg>
    ),
    key: "sortCode",
  },
  {
    label: { en: "Account number", de: "Kontonummer" },
    icon: (
      <svg
        className="size-5 text-primary-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
      </svg>
    ),
    key: "accountNumber",
  },
  {
    label: { en: "IBAN", de: "IBAN" },
    icon: (
      <svg
        className="size-5 text-primary-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
    ),
    key: "iban",
  },
  {
    label: { en: "BIC", de: "BIC" },
    icon: (
      <svg
        className="size-5 text-primary-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M7 2v11h3v9l7-12h-4l4-8z" />
      </svg>
    ),
    key: "bic",
  },
];
